import enrollCmd from "../base/enrollCmd";
import { IPluginEnroll } from "../base/pluginModels";
import { isPluginEnrollInterface } from "../decodePluginMsg";
import { IPluginCard } from "./cardModels";

/**
 * Nothing to fancy here, just checks input values and builds the JSON to send to plugin manager
 */
export const enrollOmnikeyMsg = () => {
    const enrolMessage = "{'enrollType':'" + enrollCmd.CMD_OMNIKEY + "','formatType':'ANY'}";
    return enrolMessage;
};

/**
 * construct a write to card message
 */
export const writeToOmnikeyMsg = (tagCode, tagholderName, template1, template2, expiryDate, pin, mode) => {
    const enrolMessage = "{'enrollType':'" + enrollCmd.CMD_MORPHO
        + "','formatType':'ANY', 'tagCode':'" + tagCode
        + "','tagholderName':'" + tagholderName
        + "','template1':'" + template1
        + "','template2':'" + template2
        + "','templateDuress':'','expiryDate':'" + expiryDate
        + "','writeCardData':'true','tagPin':'" + pin
        + "','tagCardMode':'" + mode + "'}";
    return enrolMessage;
};

/**
  * converts the message to object type IPluginCard.
  * @param {*} obj
  */
export const decodeOmnikeyPluginMsg = (obj) => {
    let omnikeyResult = {} as IPluginCard;

    if (isPluginEnrollInterface(obj)) {
        let jsonObj = {} as IPluginEnroll;
        if (typeof obj === "string") {
            jsonObj = JSON.parse(obj);
        }
        const cardDetails = jsonObj.enrollData.split(":");
        for (let i = 0; i < cardDetails.length; i++) {
            var data = cardDetails[i].split("=");
            if (data[0] === "data") {
                omnikeyResult.cardNumber = data[1];
            }
            if (data[0] === "formatType") {
                omnikeyResult.cardType = data[1];
            }
            if (data[0] === "cardType") {
                omnikeyResult.formatType = data[1];
            }
            if (data[0] === "rawPacsHex") {
                omnikeyResult.cardHex = data[1];
            }
            if (data[0] === "rawBits") {
                omnikeyResult.cardNoBits = parseInt(data[1]);
            }
            if (data[0] === "reversedBytes") {
                omnikeyResult.reversedBytes = parseInt(data[1]);
            }
        }
    }
    return omnikeyResult;
};
